import { render } from "./Waves.vue?vue&type=template&id=019b7c6e&scoped=true"
import script from "./Waves.vue?vue&type=script&lang=js"
export * from "./Waves.vue?vue&type=script&lang=js"

import "./Waves.vue?vue&type=style&index=0&id=019b7c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019b7c6e"]])

export default __exports__